import React from "react";
import { HEADER_HEIGHT } from "./layout.js";
import "./Main.css";
import Background from "../assets/Fondos/fondo1.png";
import BackgroundR from "../assets/Fondos/fondoV.png";
import titComunidad from "../assets/Conexion/tit_comunidad.png";
import acaEmpieza from "../assets/Conexion/aca_empieza.png";
import hi from "../assets/Conexion/hi.png";
import direccionIg from "../assets/Conexion/direccion ig.png";
import SocialBlock from "./SocialBlock.js";
import SponsorsCarousel from "./SponsorsCarousel.js";
import { SPONSORS_STRIP_ID } from "./stripClearance.js";

class Contacto extends React.Component {
  render() {
    const isMobile = window.innerWidth <= 768;
    const Back = isMobile ? BackgroundR : Background;
    const instagramHref = "https://www.instagram.com/tera.oficial.ok";

    const containerStyle = {
      position: "relative",
      backgroundImage: `url(${Back})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
      minHeight: "100dvh",
      display: "flex",
      flexDirection: "column",
      alignItems: "stretch",
      justifyContent: "flex-start",
      paddingTop: `${HEADER_HEIGHT + (isMobile ? 150 : 40)}px`,
      boxSizing: "border-box",
    };

    return (
      <div style={containerStyle}>
        <div
          style={{
            flex: 1,
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxSizing: "border-box",
            padding: isMobile ? "0 18px 28px" : "0 80px 28px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: isMobile ? "column" : "row",
              alignItems: "center",
              justifyContent: "center",
              width: "100%",
              maxWidth: "1100px",
              margin: "0 auto",
              gap: isMobile ? "24px" : "40px",
            }}
          >
            <div style={{ textAlign: isMobile ? "center" : "left" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: isMobile ? "center" : "flex-end",
                  justifyContent: isMobile ? "center" : "flex-start",
                  gap: isMobile ? "10px" : "14px",
                  marginBottom: "14px",
                }}
              >
                <img
                  src={titComunidad}
                  alt="Comunidad"
                  style={{ height: isMobile ? "60px" : "70px", width: "auto", display: "block" }}
                />
                <img
                  src={hi}
                  alt=""
                  style={{ width: isMobile ? "60px" : "70px", height: "auto", flexShrink: 0 }}
                />
              </div>

              <img
                src={acaEmpieza}
                alt="Acá empieza todo"
                style={{
                  height: isMobile ? "52px" : "58px",
                  width: "auto",
                  display: "block",
                  marginBottom: "18px",
                  marginLeft: isMobile ? "auto" : 0,
                  marginRight: isMobile ? "auto" : 0,
                }}
              />


              <a href={instagramHref} target="_blank" rel="noopener noreferrer" style={{ display: "inline-block" }}>
                <img
                  src={direccionIg}
                  alt="@tera.oficial.ok"
                  style={{ height: isMobile ? "44px" : "52px", width: "auto", display: "block" }}
                />
              </a>
            </div>
          </div>

        </div>

        <div style={{ width: "100%", display: "flex", flexDirection: "column" }}>
          <div
            id={SPONSORS_STRIP_ID}
            style={{
              width: "100%",
              backgroundColor: "#fff",
              boxSizing: "border-box",
              padding: 0,
            }}
          >
            <SponsorsCarousel isMobile={isMobile} />
          </div>

          <div style={{ width: "100%", display: "flex", justifyContent: "center", padding: isMobile ? "10px 0 16px" : "12px 0 20px" }}>
            <SocialBlock isMobile={isMobile} />
          </div>

          <p
            style={{
              margin: 0,
              padding: isMobile ? "0 18px 14px" : "0 24px 14px",
              textAlign: "center",
              fontFamily: "Halogen-Regular",
              fontSize: isMobile ? "10px" : "11px",
              lineHeight: 1.4,
              color: "rgba(255, 255, 255, 0.55)",
            }}
          >
            ¡Solo para mayores de 18! Prepárate para disfrutar de la noche. No olvides traer tu DNI para poder ingresar.
          </p>
        </div>
      </div>
    );
  }
}

export default Contacto;
